<template>
  <div class="relative inline-block group/tooltip">
    <slot />
    <div
      class="absolute z-50 px-2.5 py-1.5 text-[10px] font-bold tracking-wide text-white bg-zinc-900 border border-white/10 rounded-lg whitespace-nowrap opacity-0 scale-95 pointer-events-none transition-all duration-200 ease-out group-hover/tooltip:opacity-100 group-hover/tooltip:scale-100 shadow-xl backdrop-blur-md"
      :class="positionClasses[position]"
    >
      {{ text }}
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  text: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

withDefaults(defineProps<Props>(), {
  position: 'top',
});

const positionClasses = {
  top: 'bottom-full left-1/2 -translate-x-1/2 mb-2 origin-bottom',
  bottom: 'top-full left-1/2 -translate-x-1/2 mt-2 origin-top',
  left: 'right-full top-1/2 -translate-y-1/2 mr-2 origin-right',
  right: 'left-full top-1/2 -translate-y-1/2 ml-2 origin-left',
};
</script>